import moment from 'moment';

const initializeCountdownTimer = (callback, time) => {
    const interval = setInterval(callback, time);
    return interval;
};

const getTimeRemaining = (endtime, edgeUnit) => {
    return {
        days: edgeUnit === 'DAYS' ? Math.floor(endtime.asDays()) : endtime.days(),
        hours: edgeUnit === 'HOURS' ? Math.floor(endtime.asHours()) : endtime.hours(),
        minutes: edgeUnit === 'MINUTES' ? Math.floor(endtime.asMinutes()) : endtime.minutes(),
        seconds: edgeUnit === 'SECONDS' ? Math.floor(endtime.asSeconds()) : endtime.seconds(),
    };
};

const checkIfValidendDateAndTime = endDateAndTime => {
    let endDate = moment(endDateAndTime);

    if (endDate && endDate.isValid()) {
        return true;
    }
    endDate = moment();
    return false;
};

const deadlineDateUtil = endDate => {
    return moment.duration(endDate.diff(moment()));
};

const defineEndDate = endDateAndTime => {
    const endDate = moment(endDateAndTime);
    return endDate;
};

const endDayCheckUtil = (endDateAndTime, lastTimeUnitVisible, threshold, operator) => {
    if (operator === 'less than') {
        if (lastTimeUnitVisible === 'Seconds') {
            return deadlineDateUtil(defineEndDate(endDateAndTime)).asSeconds() <= threshold;
        }
        if (lastTimeUnitVisible === 'Minutes') {
            return deadlineDateUtil(defineEndDate(endDateAndTime)).asMinutes() < threshold;
        }
        if (lastTimeUnitVisible === 'Hours') {
            return deadlineDateUtil(defineEndDate(endDateAndTime)).asHours() < threshold;
        }
    }
    if (operator === 'more than') {
        if (lastTimeUnitVisible === 'Seconds') {
            return deadlineDateUtil(defineEndDate(endDateAndTime)).asSeconds() >= threshold;
        }
        if (lastTimeUnitVisible === 'Minutes') {
            return deadlineDateUtil(defineEndDate(endDateAndTime)).asMinutes() > threshold;
        }
        if (lastTimeUnitVisible === 'Hours') {
            return deadlineDateUtil(defineEndDate(endDateAndTime)).asHours() > threshold;
        }
    }
};

const getBeforeTimePointUtil = (timeHour, timeMinute) => {
    return moment().isBefore(moment({ h: timeHour, m: timeMinute }));
};

const getEndDateAndTime = closingTime => {
    const regex = /\d{2}:\d{2}:\d{2}/;
    const today = moment().toString();
    return today.replace(regex, `${closingTime}:00`);
};

const getStartDateAndTime = (openingTime, daysFromToday) => {
    const regex = /\d{2}:\d{2}:\d{2}/;
    const day = moment()
        .add(daysFromToday, 'd')
        .toString();
    return day.replace(regex, `${openingTime}:00`);
};

const getCurrentDayNumber = () => {
    return moment().isoWeekday() - 1;
};

const isBetweenTwoTimes = (firstTimeHour, firstTimeMinute, secondTimeHour, secondTimeMinute) => {
    return moment().isBetween(
        moment({ h: firstTimeHour, m: firstTimeMinute }),
        moment({ h: secondTimeHour, m: secondTimeMinute }),
        undefined,
        '[]',
    );
};

export {
    initializeCountdownTimer,
    getTimeRemaining,
    deadlineDateUtil,
    defineEndDate,
    checkIfValidendDateAndTime,
    endDayCheckUtil,
    getCurrentDayNumber,
    isBetweenTwoTimes,
    getEndDateAndTime,
    getStartDateAndTime,
    getBeforeTimePointUtil,
};
